module.exports = __webpack_public_path__ + "static/media/nuls.3a5447ba.svg";